import React from 'react';
import styles from '../css/ClinicInfo.module.css';

export default function ClinicInfo({
  doctorName = '',
  practiceName = '',
  practiceNumber = '',
  scriptRef = '',
  dateStr,
  timeStr,
  itemsCount,
}) {
  const now = new Date();
  const dateDisplay =
    dateStr || now.toLocaleDateString('en-ZA', { year: 'numeric', month: '2-digit', day: '2-digit' });
  const timeDisplay =
    timeStr || now.toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit' });

  const practiceLabel = practiceName || doctorName || '';

  return (
    <section className={styles.card}>
      <div className={styles.grid4} style={{ marginTop: 18 }}>
        <div className={styles.col}>
          <div>Doctor: {doctorName || '-'}</div>
          <div>Script: {scriptRef || '-'}</div>
          <div>Date: {dateDisplay}</div>
        </div>
        <div className={styles.col}>
          <div>Practice: {practiceLabel || '-'}</div>
          <div>Practice No.: {practiceNumber || '-'}</div>
          <div>Time: {timeDisplay}</div>
        </div>
        <div />
        <div />
      </div>

      <div className={styles.items}>
        No. of items: <strong>{itemsCount != null ? itemsCount : '-'}</strong>
      </div>
    </section>
  );
}

